import * as React from "react";
import { useLocation } from "react-router-dom";

import { PathEndsWithSwitch } from "features/common/routing/ends-with-routes";

import LocationTransitionWrapper from "../LocationTransitionWrapper";
import { ModalWrapper } from "../ModalJourneyWrapper";

type Props = {
  children: React.ReactElement;
  backLink?: string;
  onBackClick?: () => void;
  showOverlay?: boolean;
  coverSiteHeader?: boolean;
};

export default function PathEndsWithModalJourneyWrapper({
  children,
  backLink,
  onBackClick,
  showOverlay,
  coverSiteHeader
}: Props) {
  const location = useLocation();
  return (
    <ModalWrapper
      backLink={backLink}
      onBackClick={onBackClick}
      showOverlay={showOverlay}
      coverSiteHeader={coverSiteHeader}
      renderTransitionWrapper={({ className: wrapperClass }) => (
        <LocationTransitionWrapper className={wrapperClass}>
          <PathEndsWithSwitch location={location}>
            {children}
          </PathEndsWithSwitch>
        </LocationTransitionWrapper>
      )}
    />
  );
}
